import { RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  time_labels: {
    today: 'I dag',
    asap: 'Hurtigst muligt',
    scheduled: '{{date}}, {{time}}',
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Værelsesnummer',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Bordnummer',
  },
};
